import { PROPERTY_TYPES } from "@/features/properties/services/properties";
import { REQUIRED_FIELDS, type ImportError, type ParsedProperty } from "./fields";

interface ValidateArgs {
  parsedData: ParsedProperty[];
  columnMapping: Record<string, string>;
}

export function validatePropertyRows({ parsedData, columnMapping }: ValidateArgs): ImportError[] {
  const newErrors: ImportError[] = [];

  parsedData.forEach((row, index) => {
    REQUIRED_FIELDS.forEach((field) => {
      const csvColumn = columnMapping[field.key];
      if (!csvColumn || !row[csvColumn]?.trim()) {
        newErrors.push({
          row: index + 1,
          field: field.label,
          message: `${field.label} is required`,
        });
      }
    });

    const propertyTypeColumn = columnMapping.property_type;
    if (
      propertyTypeColumn &&
      row[propertyTypeColumn] &&
      !PROPERTY_TYPES.includes(row[propertyTypeColumn] as (typeof PROPERTY_TYPES)[number])
    ) {
      newErrors.push({
        row: index + 1,
        field: "Property Type",
        message: `Invalid property type. Must be one of: ${PROPERTY_TYPES.join(", ")}`,
      });
    }
  });

  return newErrors;
}
